export default __webpack_public_path__ + "static/media/donate_barcode.bb5cd0e7.avif";